import { render, staticRenderFns } from "./login.page.vue?vue&type=template&id=0becc631&scoped=true&"
import script from "./login.page.js?vue&type=script&lang=js&"
export * from "./login.page.js?vue&type=script&lang=js&"
import style0 from "./login.page.scss?vue&type=style&index=0&id=0becc631&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0becc631",
  null
  
)

export default component.exports